"use strict";

exports.__esModule = true;
var _AppList = require("./AppList.js");
Object.keys(_AppList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppList[key]) return;
  exports[key] = _AppList[key];
});